import React, {createContext, useContext} from "react";
import {IGameStat} from "../../types/IGameStat.ts";
import {IAIChallengeWord, IUser} from "../../common/utils/http/IResponse.ts";
import {IUsers} from "../../types/IUsers.ts";

interface UserContextType {
    user: IUser | undefined;                                        // 用户信息
    setUser: React.Dispatch<React.SetStateAction<IUsers | undefined>>; // 设置用户信息
    clearUser: () => void;                                          // 清空本地用户信息
    gameStats: IGameStat | undefined;                               // 游戏状态
    setGameStats: (gameStats: IGameStat) => void;                   // 设置游戏状态
    challengeWords: IAIChallengeWord[];                               // 挑战游戏的单词信息
    setChallengeWords: (challengeWords: IAIChallengeWord[]) => void;  // 设置挑战游戏的单词信息
    aiLevel: number;                                                // 挑战游戏的级别
    setAiLevel: React.Dispatch<React.SetStateAction<number>>;       // 设置挑战游戏的级别
    nextTime: number;                                               // 下次游戏的时间
    setNextTime: (nextTime: number) => void;                        // 设置下次游戏的时间
    hasLoginByApp: boolean,                                         // 是否通过app登录
    setHasLoginByApp: React.Dispatch<React.SetStateAction<boolean>>; // 设置通过app登录
}

export const UserContext = createContext<UserContextType | undefined>(undefined);

export const useUserContext = (): UserContextType => {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUser must be used within a UseUserContext');
    }
    return context;
};
